import angular from 'angular';

import catalogService from '../../services/catalog.service.js';

import catalogsListController from './catalogsList.controller.js';
import catalogsListItemController from './catalogsListItem.controller.js';
import catalogCreateController from './catalogCreate.controller.js';
import catalogCreateModalController from './catalogCreateModal.controller.js';
import catalogDeleteController from './catalogDelete.controller.js';
import catalogDeleteModalController from './catalogDeleteModal.controller.js';
/*import catalogDelete2Controller from './catalogDelete2.controller.js';*/
/*import catalogDelete2ModalController from './catalogDelete2Modal.controller.js';*/
import catalogXCommandController from './catalogXCommand.controller.js';
import catalogXCommandModalController from './catalogXCommandModal.controller.js';
import catalogGetDocumentController from './catalogGetDocument.controller.js';
import catalogEnableController from './catalogEnable.controller.js';

export default angular.module('components.catalog', [
    catalogService
])
    .component('catalogsList', {
        template: require('./catalogsList.pug')(),
        bindings: {
        },
        controller: catalogsListController
    })
    .component('catalogsListItem', {
        template: require('./catalogsListItem.pug')(),
        bindings: {
            item: '<'
        },
        controller: catalogsListItemController
    })
    .component('catalogCreate', {
        template: require('./catalogCreate.pug')(),
        bindings: {
            text: '@',
            onDone: '&'
        },
        controller: catalogCreateController
    })
    .component('catalogCreateModal', {
        template: require('./catalogCreateModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: catalogCreateModalController
    })
    .component('catalogDelete', {
        template: require('./catalogDelete.pug')(),
        bindings: {
            catalog: '<',
            text: '@',
            onDone: '&'
        },
        controller: catalogDeleteController
    })
    .component('catalogDeleteModal', {
        template: require('./catalogDeleteModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: catalogDeleteModalController
    })
    /*
    .component('catalogDelete2', {
        template: require('./catalogDelete2.pug')(),
        bindings: {
            id: '<',
            text: '@',
            onDone: '&'
        },
        controller: catalogDelete2Controller
    })
    .component('catalogDelete2Modal', {
        template: require('./catalogDelete2Modal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: catalogDelete2ModalController
    })
    */
    .component('catalogGetDocument', {
        template: require('./catalogGetDocument.pug')(),
        bindings: {
            catalog: '<',
            schema: '@',
            docid: '<'
        },
        controller: catalogGetDocumentController
    })
    .component('catalogXCommand', {
        template: require('./catalogXCommand.pug')(),
        bindings: {
            text: '@',
            content: '<',
            command: '@',
            onDone: '&',
            title: '@'
        },
        controller: catalogXCommandController
    })
    .component('catalogXCommandModal', {
        template: require('./catalogXCommandModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: catalogXCommandModalController
    })
    .component('catalogEnable', {
        bindings: {
            id: '<',
            done: '&'
        },
        template: require('./catalogEnable.pug')(),
        controller: catalogEnableController
    })
    .name;
